import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async verificaProcesso ({ commit }, numeroProcesso) {
    const data = await axios({
      method: 'GET',
      url: `manutencao/plantaMemorial/verificaProcesso?numeroProcesso=${numeroProcesso}`,
      loaderText: 'Verificando processo'
    })
    return data
  },
  async geraJsonPlanilha ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `manutencao/plantaMemorial/geraJsonPlanilha`,
      loaderText: 'Gerando json da planilha no ARCGIS',
      notMessage: true
    })
    return data
  },
  async gerarPlantaMemorialJSON ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      data: dados,
      url: `manutencao/plantaMemorial/gerarPlantaMemorialJSO`,
      loaderText: 'Gerando planta memorial'
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/manutencao.js